import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router";

import { installHistorySync } from "@/nav/historySync";
import { RefreshProvider } from "@/nav/navigation";

import { appRoutes } from "./router/appRoutes";

// The platform stylesheet is part of the entry, so the build links it in
// <head> BEFORE the user's CSS link (scripts/indexHtml.ts) — user CSS wins by
// document order. Imported from a lazy route it would load after, and lose.
import "./app/globals.css";
// After globals.css on purpose: gold-effects overrides .avatar-* rules that
// globals.css also defines, so the cascade order lives in this import order.
import "./styles/gold-effects.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("[web-client] index.html has no #root element");
}

// The app owns every non-API path on its origin (the API pod serves this
// bundle for them); only the bundle's own files live under /app/.
// Before the router exists: the UI's own history writes must reach it.
installHistorySync();
const router = createBrowserRouter(appRoutes);

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <RefreshProvider>
      <RouterProvider router={router} />
    </RefreshProvider>
  </React.StrictMode>,
);
